export default __webpack_public_path__ + "static/media/deli1.a5f5e6bc.svg";